import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { t } from '@/i18n';
import type { NextStep, NextStepAction } from './nextStep';
import { TONE_BORDER_L, TONE_TEXT } from './tones';

const ACTION_LABEL: Record<NextStepAction, string> = {
  moveDate: 'crm.deals.nextStep.actions.moveDate',
  won: 'crm.deals.stepper.won',
  lost: 'crm.deals.stepper.lost',
  call: 'crm.deals.nextStep.actions.call',
  logCall: 'crm.deals.nextStep.actions.logCall',
  enterValue: 'crm.deals.nextStep.actions.enterValue',
  setDate: 'crm.deals.nextStep.actions.setDate',
  moveNext: 'crm.deals.nextStep.actions.moveNext',
};

interface Props {
  step: NextStep;
  /** `call` renders as a `tel:` link when the contact has a phone. */
  contactPhone?: string | null;
  disabled?: boolean;
  onAction: (action: NextStepAction, step: NextStep) => void;
}

/** "Co dalej?" — one derived recommendation with its one-click actions. */
export function NextStepCard({ step, contactPhone, disabled, onAction }: Props) {
  return (
    <div className={cn('bg-muted/40 rounded-md border border-l-4 p-3 text-sm', TONE_BORDER_L[step.tone])}>
      <div className="text-muted-foreground text-[11px] font-medium uppercase tracking-wide">
        {t('crm.deals.nextStep.title')}
      </div>
      <p className="mt-0.5">{t(`crm.deals.nextStep.${step.textKey}`, step.params)}</p>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {step.actions.map((action) =>
          action === 'call' && contactPhone ? (
            <Button key={action} asChild variant="outline" size="xs">
              <a href={`tel:${contactPhone}`} onClick={() => onAction(action, step)}>
                {t(ACTION_LABEL[action])}
              </a>
            </Button>
          ) : (
            <Button
              key={action}
              variant={action === 'lost' ? 'outline' : action === 'won' || action === 'moveNext' ? 'default' : 'outline'}
              size="xs"
              disabled={disabled}
              className={cn(action === 'lost' && TONE_TEXT.destructive)}
              onClick={() => onAction(action, step)}
            >
              {t(ACTION_LABEL[action])}
            </Button>
          ),
        )}
      </div>
    </div>
  );
}
